// extracted by mini-css-extract-plugin
export default {"drawer":"PY","drawerheader":"QY","retake_quiz_bottom_bar":"RY","extra_drawer":"SY","not_answered_questions":"TY","question_ui":"UY","accordion_details":"VY","retake_quiz":"WY","accordions":"XY","accordion_root":"YY","accordion_summary_text":"ZY","animation":"aZ","show_animation":"bZ","overflow_hidden":"cZ"};
    if(module.hot) {
      // 1738836198183
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  